import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const MilanoteLogoMediumIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={48}
        height={48}
        fill="none"
        viewBox="0 0 48 48"
        className="Icon milanote-logo-medium"
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M24 0c13.255 0 24 10.745 24 24S37.255 48 24 48 0 37.255 0 24 10.745 0 24 0Zm10.667 14.667c0-1.188-1.437-1.783-2.276-.943L24 22.114l-8.39-8.39c-.84-.84-2.277-.245-2.277.943v18.666c0 .737.597 1.334 1.334 1.334h18.666c.737 0 1.334-.597 1.334-1.334V14.667ZM24 25.886 30.114 32H17.886L24 25.886Zm8-8v12.228L25.886 24 32 17.886Zm-16 0L22.114 24 16 30.114V17.886Z"
            clipRule="evenodd"
        />
    </svg>
);
const Memo = memo(MilanoteLogoMediumIcon);
export default Memo;
